import { render, staticRenderFns } from "./JoinTelemedicine.vue?vue&type=template&id=0aa7a3ac&scoped=true&"
import script from "./JoinTelemedicine.vue?vue&type=script&lang=js&"
export * from "./JoinTelemedicine.vue?vue&type=script&lang=js&"
import style0 from "./JoinTelemedicine.vue?vue&type=style&index=0&id=0aa7a3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa7a3ac",
  null
  
)

export default component.exports